module.exports = __webpack_public_path__ + "img/fsilogo.23e211f8.png";